export const getDateRange = (range) => {
  const now = new Date();
  let fromDate = null;
  let toDate = null;

  switch (range) {
    case "daily":
      fromDate = new Date(now);
      fromDate.setHours(0, 0, 0, 0);
      toDate = new Date(now);
      toDate.setHours(23, 59, 59, 999);
      break;

    case "next7":
      fromDate = new Date(now);
      fromDate.setHours(0, 0, 0, 0);
      toDate = new Date(now);
      toDate.setDate(now.getDate() + 6);
      toDate.setHours(23, 59, 59, 999);
      break;

    case "last7":
      fromDate = new Date(now);
      fromDate.setDate(now.getDate() - 6);
      fromDate.setHours(0, 0, 0, 0);
      toDate = new Date(now);
      toDate.setHours(23, 59, 59, 999);
      break;

    case "month":
      fromDate = new Date(now.getFullYear(), now.getMonth(), 1); // First day of current month
      fromDate.setHours(0, 0, 0, 0);
      toDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of current month
      toDate.setHours(23, 59, 59, 999);
      break;

    case "all":
    default:
      fromDate = null;
      toDate = null;
      break;
  }

  return { fromDate, toDate };
};



export function formatLocalDateTime(dateObj, timeObj) {
  if (!dateObj || !timeObj) return null;

  const combinedDate = new Date(
    dateObj.getFullYear(),
    dateObj.getMonth(),
    dateObj.getDate(),
    timeObj.getHours(),
    timeObj.getMinutes()
  );

  const pad = (n) => n.toString().padStart(2, "0");

  return `${combinedDate.getFullYear()}-${pad(combinedDate.getMonth() + 1)}-${pad(combinedDate.getDate())}T${pad(combinedDate.getHours())}:${pad(combinedDate.getMinutes())}:00`;
}

export function getCurrentLocalDateTime() {
  const now = new Date();
  const pad = (n) => n.toString().padStart(2, "0");

  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
}
